import type { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'

import { getLocalStorageItem, setLocalStorageItem } from '~/libs/localStorage'
import { parseJepxAreaCodes } from '~/models/area'

/**
 * 入札一覧のエリアフィルタ (AC-BSP-019) の選択 (端末単位、localStorage)。
 *
 * 共通 spec AC-SC-031 [P0]「フィルタバーを持つ全画面で選択状態を保持し、再訪時に
 * 復元する」 による (#10122)。 受渡日は AC-BSP-043 で毎回翌日に戻すため対象外。
 *
 * 保存するのは**ユーザーが選んだ値だけ**。 取引不可になったエリアを画面側が選択から
 * 落とした結果は保存しない (受渡日ごとに取引可能エリアが変わるため、 落とした値を
 * 保存すると、 取引できる日に戻っても選択が戻らない)。
 */
const AREA_FILTER_KEY = 'ebalance-spot-area-filter'

/** 未保存・不正値は undefined (= 呼び出し側の既定値を使う)。 空配列は「全エリア」 の選択として返す。 */
export const loadSpotAreaFilter = (): Set<AreaCode> | undefined => {
  const raw = getLocalStorageItem(AREA_FILTER_KEY)
  const areas = raw === undefined ? undefined : parseJepxAreaCodes(raw)
  return areas === undefined ? undefined : new Set(areas)
}

export const saveSpotAreaFilter = (areas: ReadonlySet<AreaCode>): void => {
  setLocalStorageItem(AREA_FILTER_KEY, JSON.stringify([...areas]))
}
